import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'María G.',
    initial: 'M',
    text: 'Las recetas fueron lo que más me ayudó. Todo es fácil de preparar y realmente me sentí mucho mejor siguiendo el plan.'
  }, {
    name: 'Patricia L.',
    initial: 'P',
    text: 'La lista de compras me facilitó todo. Ya no tenía que pensar qué comprar cada semana.'
  }, {
    name: 'Carmen R.',
    initial: 'C',
    text: 'Las bebidas son deliciosas. Fue lo que más me ayudó con la digestión.'
  }, {
    name: 'Laura M.',
    initial: 'L',
    text: 'El plan completo con los bonos hace que todo sea mucho más fácil de seguir.'
  }];
  return <section className="py-24 bg-[#F2E8DA]/50 backdrop-blur-[2px]" data-id="element-344">
      <div className="container mx-auto px-6 max-w-5xl" data-id="element-345">
        <motion.h2 className="text-3xl md:text-4xl font-heading font-semibold text-text-dark text-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-346">
          Lo que dicen quienes ya los tienen
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-347">
          {testimonials.map((testimonial, index) => <motion.div key={index} className="bg-white rounded-2xl p-8 shadow-sm border border-beige" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} data-id="element-348">
              <div className="flex items-center mb-4" data-id="element-349">
                <div className="w-12 h-12 rounded-full bg-sage text-white flex items-center justify-center font-heading font-semibold text-xl mr-4" data-id="element-350">
                  {testimonial.initial}
                </div>
                <div data-id="element-351">
                  <div className="font-semibold text-text-dark" data-id="element-352">
                    {testimonial.name}
                  </div>
                  <div className="flex text-gold-soft mt-1" data-id="element-353">
                    {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-current" data-id="element-354" />)}
                  </div>
                </div>
              </div>
              <p className="text-text-medium italic text-lg leading-relaxed" data-id="element-355">
                "{testimonial.text}"
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}